import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=2e0b174b&scoped=true"
import script from "./AppItem.vue?vue&type=script&lang=js"
export * from "./AppItem.vue?vue&type=script&lang=js"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=2e0b174b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b174b",
  null
  
)

export default component.exports